module.exports = __webpack_public_path__ + "static/img/bg.afb7b404.jpg";